<template>
    <div :class="assessmentClass" >
        <span v-if="status!==1" class="assessment-badge"><i :class="statuses[status].icon"></i></span>
        <span v-else class="assessment-badge">{{remainingQuestions}}</span>
        <div class="overlay d-flex align-items-center justify-content-center" v-if="!status">
            <span>To unlock this you must complete the <strong>{{previousAssessment}}</strong></span>
        </div>
        <a :href="status===1? url : '#'" :class="aClass" >
            <img class="assessment-icon" :src="types[type].icon">
            <div class="assessment-data">
                <h5>{{types[type].name}}</h5>
                <p>{{statuses[status].name}}</p>
            </div>
        </a>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                required: true,
                type: Number,
            },
            url: {
                default: "#"
            },
            status: {
                default: 0
            },
            remainingQuestions: {
                default: null
            },
            previousAssessment: {
                default: ''
            },
            columnWidth: {
                default: 6
            }
        },
        data() {
            return {
                types: [
                    {
                        name: "Job Interests",
                        color: "blue-aqua-light ",
                        icon: "/images/assessment-icons/1-job-interests.svg"
                    },
                    {name: "Job Skills", color: "orange ", icon: "/images/assessment-icons/2-job-skills.svg"},
                    {name: "Reading", color: "purple ", icon: "/images/assessment-icons/3-literacy.svg"},
                    {name: "Math", color: "green ", icon: "/images/assessment-icons/4-numeracy.svg"},

                ],
                statuses: [
                    {name: 'Looked', className: 'assessment-locked', mask: true, icon: 'fas fa-lock'},
                    {name: 'Incomplete', className: 'assessment-incompleted', mask: false, icon: null},
                    {name: 'Completed', className: 'assessment-completed', mask: true, icon: 'fas fa-check'},
                ]

            }
        },
        computed: {
            assessmentClass() {
                return "col-" + this.columnWidth + " assessment-block " + this.types[this.type].color + this.statuses[this.status].className;
            },
            aClass(){
                return this.status !== 1? 'assessment-link cursor-no-drop' : 'assessment-link';
            }
        },
        methods: {
            goToAssessment() {
                console.log(this.status, this.url);
                // window.location = this.url
            }
        }
    }
</script>

<style>
    .assessment-completed{
        cursor: default !important;
    }
    .cursor-no-drop{
        cursor: default !important;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/assessments/index/AssessmentCard.vue